import axios from 'axios'
import store from '@/store'
import { EventBus } from '@/event-bus.js'

export default class SessionAuthService {
  constructor () {
    this.loginUrl = process.env.VUE_APP_SESSION_LOGIN_URL ? process.env.VUE_APP_SESSION_LOGIN_URL : '/login'
    this.logoutUrl = process.env.VUE_APP_SESSION_LOGOUT_URL ? process.env.VUE_APP_SESSION_LOGOUT_URL : '/logout'
    this.userInfoUrl = process.env.VUE_APP_SESSION_GET_USERINFO_URL ? process.env.VUE_APP_SESSION_GET_USERINFO_URL : '/user/info'
  }

  async login (data = {}) {
    const { username, password } = data
    return axios.post(this.loginUrl, {
      username: username,
      password: password
    })
      .then(response => {
        store.commit('session/mutateAuthenticated', {
          accessToken: 'token',
          idToken: '1',
          expiresIn: 2 * 60 * 60
        })
        store.dispatch('session/getUserInfo')
        store.dispatch('notifications/initializeNotifications')
        EventBus.$emit('routePush', { path: '/' })
      })
      .catch(error => {
        throw error
      })
  }

  async logout () {
    await axios.get(this.logoutUrl)
  }

  handleAuthentication () {
    return new Promise((resolve, reject) => {
      resolve({})
    })
  }

  getUserInfo () {
    return new Promise(async (resolve, reject) => {
      const userInfo = await axios.get(this.userInfoUrl)
        .then(response => {
          if (response.data) {
            // Destructuring assignment using the rest pattern
            // https://javascript.info/destructuring-assignment#the-rest-pattern
            const {
              id = null,
              nickname = 'Anonimo',
              role = '',
              roles = [],
              avatar = '',
              ...extra
            } = response.data
            let userProfile = {
              id,
              nickname,
              role,
              roles,
              avatar,
              extra
            }
            return userProfile
          }
        })
        .catch(() => {
          return {
            nickname: 'Anonimo'
          }
        })
      resolve(userInfo)
    })
  }

  updateTokens () {
    return new Promise((resolve, reject) => {
      // https://auth0.com/docs/api-auth/tutorials/silent-authentication#renew-expired-tokens
      this.auth0.checkSession({}, (err, authResult) => {
        if (authResult) {
          resolve(authResult)
        } else {
          return reject(err)
        }
      })
    })
  }
}
